import { render, staticRenderFns } from "./GoodsButtonPrice.vue?vue&type=template&id=a92e66c6&scoped=true"
import script from "./GoodsButtonPrice.vue?vue&type=script&lang=js"
export * from "./GoodsButtonPrice.vue?vue&type=script&lang=js"
import style0 from "./GoodsButtonPrice.vue?vue&type=style&index=0&id=a92e66c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92e66c6",
  null
  
)

export default component.exports